export type OriginDelta = {
  dx: number;
  dy: number;
  scaleX: number;
  scaleY: number;
};

export function originDelta(from: DOMRect | null, to: DOMRect): OriginDelta {
  if (!from || to.width === 0 || to.height === 0) {
    return { dx: 0, dy: 0, scaleX: 1, scaleY: 1 };
  }

  return {
    dx: from.left + from.width / 2 - (to.left + to.width / 2),
    dy: from.top + from.height / 2 - (to.top + to.height / 2),
    scaleX: from.width / to.width,
    scaleY: from.height / to.height,
  };
}
